import { SearchStatus } from '../+types/search-status.type';
import { PdfViewerEventType, PdfViewerFetchSearchResultsEvent, PdfViewerSearchIsAvailableEvent, PdfViewerSearchIsUnavailableEvent } from '../+types/pdf-viewer-event.type';
import { PdfViewerSearchAvailabiltyPendoTrackEvent, PdfViewerSearchResultsPendoTrackEvent } from '../+types/pdf-viewer-pendo-track-event.type';
export class SearchService {
    constructor(assetId, searchAvailableFunction, searchFunction, pageNumbers, eventBus, pendoService) {
        this.assetId = assetId;
        this.searchAvailableFunction = searchAvailableFunction;
        this.searchFunction = searchFunction;
        this.pageNumbers = pageNumbers;
        this.eventBus = eventBus;
        this.pendoService = pendoService;
        this._searchState = {
            text: '',
            pages: [],
            status: SearchStatus.Done
        };
        const now = performance.now();
        this.searchAvailablePromise = this.searchAvailableFunction(assetId);
        this.searchAvailablePromise.then(isAvailable => {
            var _a, _b;
            const timeMs = Math.floor(performance.now() - now);
            if (isAvailable) {
                this.eventBus.dispatch(new PdfViewerSearchIsAvailableEvent());
                (_a = this.pendoService) === null || _a === void 0 ? void 0 : _a.track(new PdfViewerSearchAvailabiltyPendoTrackEvent({ isAvailable, timeMs }));
            }
            else {
                this.eventBus.dispatch(new PdfViewerSearchIsUnavailableEvent());
                (_b = this.pendoService) === null || _b === void 0 ? void 0 : _b.track(new PdfViewerSearchAvailabiltyPendoTrackEvent({ isAvailable, timeMs }));
            }
        });
        this.eventBus.on(PdfViewerEventType.InitializeSearch, (event) => {
            this._searchState = { text: event.payload.text, pages: [], status: SearchStatus.Pending };
            if (event.payload.text === '') {
                this.eventBus.dispatch(new PdfViewerFetchSearchResultsEvent({ text: '', pages: [], status: SearchStatus.Done }));
                return;
            }
            if (!event.payload.isDebounced) {
                return;
            }
            if (this.searchPromise) {
                this.searchPromise.cancel();
                this.searchPromise = null;
            }
            this.searchPromise = this.searchFunction(this.assetId, event.payload.text, this.pageNumbers);
            this.searchPromise
                .then(pages => {
                var _a;
                if (event.payload.text === this.searchState.text) {
                    this._searchState = { text: event.payload.text, pages: pages, status: SearchStatus.Done };
                    this.eventBus.dispatch(new PdfViewerFetchSearchResultsEvent(this.searchState));
                    (_a = this.pendoService) === null || _a === void 0 ? void 0 : _a.track(new PdfViewerSearchResultsPendoTrackEvent({ text: event.payload.text, pages: pages.map(String) }));
                }
            })
                .catch(() => {
                this._searchState = { text: event.payload.text, pages: [], status: SearchStatus.Done };
                this.eventBus.dispatch(new PdfViewerFetchSearchResultsEvent(this.searchState));
            });
        });
    }
    get searchState() {
        return this._searchState;
    }
    destroy() {
        if (this.searchAvailablePromise) {
            this.searchAvailablePromise.cancel();
            this.searchAvailablePromise = null;
        }
        if (this.searchPromise) {
            this.searchPromise.cancel();
            this.searchPromise = null;
        }
    }
}
//# sourceMappingURL=search.service.js.map